import React from 'react';
import InnerDocumentList from '../../document/InnerDocumentList';
import Constants from '../../../util/Constants';
import PropertyDocTable from '../../document/PropertyDocTable';

class DocumentTab extends React.Component {
  render() {
    const tab = this.props.activeTab;
    return (
      <div className={`tab-pane fade ${tab === 'document' ? 'show active in' : ''}`}>
        <div className="row">
          <div className="col-md-12">
            <PropertyDocTable id={this.props.id} type={Constants.Lead} {...this.props} reload={this.props.reload} />
            {/* <InnerDocumentList id={this.props.id} type={this.props.type} {...this.props}
              reload={this.props.reload} /> */}
          </div>
        </div>
      </div>
    );
  }
}
export default DocumentTab;